import { render, staticRenderFns } from "./Report-9.vue?vue&type=template&id=b28cc20e&scoped=true"
import script from "./Report-9.vue?vue&type=script&lang=js"
export * from "./Report-9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28cc20e",
  null
  
)

export default component.exports